module.exports = __webpack_public_path__ + "static/media/IMG_20181115_163906 - Citizen Datasteward.6dbfdee0.jpg";